exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mybtn{\n\tdisplay: none;\n}\n.hide{\n\tdisplay: inline-block !important;\n}\n", ""]);

// exports
